import { render, staticRenderFns } from "./SubBtn.vue?vue&type=template&id=a830c744&scoped=true&"
import script from "./SubBtn.vue?vue&type=script&lang=ts&"
export * from "./SubBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a830c744",
  null
  
)

export default component.exports